/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateCompetitionBodyOnboardingSectionGetStartedStepsInner } from './CreateCompetitionBodyOnboardingSectionGetStartedStepsInner';
import {
    CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSON,
    CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSONTyped,
    CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSON,
    CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSONTyped,
} from './CreateCompetitionBodyOnboardingSectionGetStartedStepsInner';

/**
 * Configuration for the competition onboarding experience
 * @export
 * @interface CreateCompetitionBodyOnboardingSection
 */
export interface CreateCompetitionBodyOnboardingSection {
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyOnboardingSection
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyOnboardingSection
     */
    description?: string;
    /**
     * 
     * @type {Array<CreateCompetitionBodyOnboardingSectionGetStartedStepsInner>}
     * @memberof CreateCompetitionBodyOnboardingSection
     */
    getStartedSteps?: Array<CreateCompetitionBodyOnboardingSectionGetStartedStepsInner>;
    /**
     * 
     * @type {CreateCompetitionBodyOnboardingSectionGetStartedStepsInner}
     * @memberof CreateCompetitionBodyOnboardingSection
     */
    instantReward?: CreateCompetitionBodyOnboardingSectionGetStartedStepsInner;
    /**
     * 
     * @type {CreateCompetitionBodyOnboardingSectionGetStartedStepsInner}
     * @memberof CreateCompetitionBodyOnboardingSection
     */
    prizePool?: CreateCompetitionBodyOnboardingSectionGetStartedStepsInner;
}

/**
 * Check if a given object implements the CreateCompetitionBodyOnboardingSection interface.
 */
export function instanceOfCreateCompetitionBodyOnboardingSection(value: object): value is CreateCompetitionBodyOnboardingSection {
    return true;
}

export function CreateCompetitionBodyOnboardingSectionFromJSON(json: any): CreateCompetitionBodyOnboardingSection {
    return CreateCompetitionBodyOnboardingSectionFromJSONTyped(json, false);
}

export function CreateCompetitionBodyOnboardingSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompetitionBodyOnboardingSection {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'getStartedSteps': json['getStartedSteps'] == null ? undefined : ((json['getStartedSteps'] as Array<any>).map(CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSON)),
        'instantReward': json['instantReward'] == null ? undefined : CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSON(json['instantReward']),
        'prizePool': json['prizePool'] == null ? undefined : CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSON(json['prizePool']),
    };
}

export function CreateCompetitionBodyOnboardingSectionToJSON(json: any): CreateCompetitionBodyOnboardingSection {
    return CreateCompetitionBodyOnboardingSectionToJSONTyped(json, false);
}

export function CreateCompetitionBodyOnboardingSectionToJSONTyped(value?: CreateCompetitionBodyOnboardingSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'getStartedSteps': value['getStartedSteps'] == null ? undefined : ((value['getStartedSteps'] as Array<any>).map(CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSON)),
        'instantReward': CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSON(value['instantReward']),
        'prizePool': CreateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSON(value['prizePool']),
    };
}

